import * as KycUsageAction from './action';
const initialState = {
    kycUsageMeteringResponse: null,
    kycUsageStatsFile: null,
    downloadKycPricingRequestTemplateSuccess: {},
    downloadKycPricingRequestTemplateFailure: {},
    submitKycPricingRequestSuccess: {},
    submitKycPricingRequestFailure: {},
    kycApiUsageStatsFile: null
}
const KycUsageReducer = (state = initialState, action) => {
    switch (action.type) {
        case KycUsageAction.KYC_USAGE_METERING_RESPONSE:
            return state = {
                ...state,
                kycUsageMeteringResponse: action.data
            }
        case KycUsageAction.KYC_USAGE_STATS_RESPONSE:
            return state = {
                ...state,
                kycUsageStatsFile: action.data
            }
        case KycUsageAction.DOWNLOAD_KYC_PRICING_REQUEST_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                downloadKycPricingRequestTemplateSuccess: action.data
            }
        case KycUsageAction.DOWNLOAD_KYC_PRICING_REQUEST_TEMPLATE_FAILURE:
            return state = {
                ...state,
                downloadKycPricingRequestTemplateFailure: action.error
            }
        case KycUsageAction.SUBMIT_KYC_PRICING_REQUEST_SUCCESS:
            return state = {
                ...state,
                submitKycPricingRequestSuccess: action.data
            }
        case KycUsageAction.SUBMIT_KYC_PRICING_REQUEST_FAILURE:
            return state = {
                ...state,
                submitKycPricingRequestFailure: action.error
            }
        case KycUsageAction.KYC_API_USAGE_STATS_RESPONSE:
            return state = {
                ...state,
                kycApiUsageStatsFile: action.data
            }
        default: return state
    }
};

export default KycUsageReducer; 